"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_ChartDimension = exports.bpfrpt_proptype_ChartDimensionList = exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread9 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var _ChartData = _interopRequireDefault(require("../chartdata/ChartData"));

var _applyDimension2 = _interopRequireDefault(require("../util/applyDimension"));

var _applyScaledValue = _interopRequireDefault(require("../util/applyScaledValue"));

var _applyPrimitiveDimensionProps = _interopRequireDefault(require("../util/applyPrimitiveDimensionProps"));

var _defaultScale = _interopRequireDefault(require("../util/defaultScale"));

var _SpruceClassName = _interopRequireDefault(require("stampy/lib/util/SpruceClassName"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _definitions = require("../definitions");

var bpfrpt_proptype_ChartDimensionList = _propTypes.default.arrayOf(_propTypes.default.shape({
  dimensionName: _propTypes.default.string.isRequired,
  dimension: function dimension() {
    return (typeof ChartDimension === "function" ? _propTypes.default.instanceOf(ChartDimension).isRequired : _propTypes.default.any.isRequired).apply(this, arguments);
  }
}).isRequired);

exports.bpfrpt_proptype_ChartDimensionList = bpfrpt_proptype_ChartDimensionList;
var bpfrpt_proptype_ChartDimension = {
  columnKey: _propTypes.default.string.isRequired,
  columns: _propTypes.default.arrayOf(_propTypes.default.string.isRequired).isRequired,
  scaleKey: _propTypes.default.string.isRequired,
  scaleTypeKey: _propTypes.default.string.isRequired,
  scaleUpdateKey: _propTypes.default.string.isRequired,
  scales: _propTypes.default.arrayOf(_propTypes.default.shape({
    column: _propTypes.default.string.isRequired,
    scale: _propTypes.default.func.isRequired
  }).isRequired).isRequired
};
exports.bpfrpt_proptype_ChartDimension = bpfrpt_proptype_ChartDimension;

var Chart =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Chart, _Component);

  function Chart(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, Chart);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Chart).call(this, _props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dimensions", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scaledData", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "applyCanvasSize", function applyCanvasSize(props) {
      var width = props.width,
          height = props.height,
          _props$padding = props.padding,
          padding = _props$padding === void 0 ? [] : _props$padding; // $FlowBug: flow cant handle default assignment on array destructuring

      var _padding = (0, _slicedToArray2.default)(padding, 4),
          _padding$ = _padding[0],
          top = _padding$ === void 0 ? 0 : _padding$,
          _padding$2 = _padding[1],
          right = _padding$2 === void 0 ? 0 : _padding$2,
          _padding$3 = _padding[2],
          bottom = _padding$3 === void 0 ? 0 : _padding$3,
          _padding$4 = _padding[3],
          left = _padding$4 === void 0 ? 0 : _padding$4;

      if (props.childChart) {
        return (0, _objectSpread9.default)({}, props, {
          width: width,
          height: height,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        });
      }

      return (0, _objectSpread9.default)({}, props, {
        width: Math.max(width - left - right, 0),
        // clamp negatives
        height: Math.max(height - top - bottom, 0),
        // clamp negatives
        outerWidth: width,
        outerHeight: height,
        top: top,
        right: right,
        bottom: bottom,
        left: left
      });
    });
    _this.dimensions = _this.getDimensions(_props);
    _this.scaledData = _this.getScaledData(_props);
    return _this;
  }

  (0, _createClass2.default)(Chart, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.dimensions = this.getDimensions(nextProps);
      this.scaledData = this.getScaledData(nextProps);
    }
  }, {
    key: "getDimensions",
    value: function getDimensions(props) {
      var _this2 = this;

      // collect the children propTypes and merge chartType
      var childrenProps = _react.Children.toArray(props.children).filter(function (child) {
        return child && child.props && child.type;
      }).map(function (child) {
        // make each child inherit chart.props
        return (0, _objectSpread9.default)({}, props, child.props, {
          chartType: child.type.chartType
        });
      });

      return props.dimensions.map(function (dimensionName) {
        var columnKey = "".concat(dimensionName, "Column");
        var scaleKey = "".concat(dimensionName, "Scale");
        var scaleTypeKey = "".concat(dimensionName, "ScaleType");
        var scaleUpdateKey = "".concat(dimensionName, "ScaleUpdate");
        var columnsArray = childrenProps // concat default columns onto child columns
        .map(function (child) {
          return [].concat(child[columnKey]).concat(props[columnKey]);
        }).reduce(function (rr, ii) {
          return [].concat((0, _toConsumableArray2.default)(rr), (0, _toConsumableArray2.default)(ii));
        }, []).filter(Boolean);
        var columns = (0, _toConsumableArray2.default)(new Set(columnsArray));
        var dimension = {
          columnKey: columnKey,
          columns: columns,
          scaleKey: scaleKey,
          scaleTypeKey: scaleTypeKey,
          scaleUpdateKey: scaleUpdateKey,
          scales: columns.map(function (column) {
            // eslint-disable-next-line no-unused-vars
            var scaleUpdate = typeof props[scaleUpdateKey] === 'function' ? props[scaleUpdateKey] : function (scale, props) {
              return scale;
            }; // to calculate the scale you need
            // primitiveDimension (range)
            // columns (domain)
            // scaleType
            // primitiveDimensionProps (range)
            // data (domain)
            // set(scaleUpdate(defaultScale, props))

            return {
              column: column,
              scale: scaleUpdate((0, _defaultScale.default)({
                primitiveDimension: dimensionName,
                columns: columns,
                scaleType: props[scaleTypeKey],
                primitiveDimensionProps: (0, _applyPrimitiveDimensionProps.default)(dimensionName, _this2.applyCanvasSize(props)),
                data: props.data
              }), props)
            };
          })
        }; // group children by their scaleGroup name (defaults to dimensionName)

        return {
          dimensionName: dimensionName,
          dimension: dimension
        };
      });
    }
  }, {
    key: "getScaledData",
    value: function getScaledData(props) {
      var _this3 = this;

      var data = props.frame || props.data;
      return data.rows.map(function (row) {
        return _this3.dimensions.reduce(function (dimensionMap, _ref) {
          var dimension = _ref.dimension,
              dimensionName = _ref.dimensionName;
          return (0, _objectSpread9.default)({}, dimensionMap, (0, _defineProperty2.default)({}, dimensionName, dimension.scales.reduce(function (scaleMap, _ref2) {
            var scale = _ref2.scale,
                column = _ref2.column;
            return (0, _objectSpread9.default)({}, scaleMap, (0, _defineProperty2.default)({}, column, (0, _applyScaledValue.default)(dimensionName, scale, row[column], _this3.applyCanvasSize(props))));
          }, {})));
        }, {});
      });
    }
  }, {
    key: "getChildProps",
    value: function getChildProps(props) {
      var _this4 = this;

      var inheritedProps = this.applyCanvasSize((0, _objectSpread9.default)({}, this.props, props)); // Create custom scales from dimensions if required

      var customScales = this.dimensions.map(function (_ref3) {
        var dimension = _ref3.dimension,
            dimensionName = _ref3.dimensionName;

        var _applyDimension = (0, _applyDimension2.default)(dimension, inheritedProps),
            scaleUpdate = _applyDimension.scaleUpdate,
            scaleTypeName = _applyDimension.scaleTypeName; // if child has defined either a custom scale or scaleType
        // we need to recreate the scale based on the custom props


        if (scaleUpdate || scaleTypeName) {
          var scale = (0, _defaultScale.default)({
            primitiveDimension: dimensionName,
            columns: dimension.columns,
            scaleType: scaleTypeName,
            primitiveDimensionProps: (0, _applyPrimitiveDimensionProps.default)(dimensionName, inheritedProps),
            data: inheritedProps.data
          }); // if custom scale is a function pass the default scale through it.

          return {
            dimensionName: dimensionName,
            scale: typeof scaleUpdate === 'function' ? scaleUpdate(scale.copy(), inheritedProps) : scale
          };
        } else {
          return {
            dimensionName: dimensionName,
            scale: null
          };
        }
      }); // Create functions to get a value for each row for each dimension

      var getters = this.dimensions.reduce(function (getMap, _ref4) {
        var dimensionName = _ref4.dimensionName;
        var customScale = customScales.find(function (ii) {
          return ii.dimensionName === dimensionName;
        }); // If this dimension has a custom scale then use it rather than the pre-scaled data

        if (customScale && customScale.scale) {
          var scale = customScale.scale;
          return (0, _objectSpread9.default)({}, getMap, (0, _defineProperty2.default)({}, dimensionName, function (index, key) {
            var value = (inheritedProps.frame || inheritedProps.data).rows[index][key];
            return (0, _applyScaledValue.default)(dimensionName, scale, value, inheritedProps);
          }));
        } // default getter just gets from scaledData via a index => dimensionName => key
        // the primitive dimension quirks have already been applied via applyScaledValue


        return (0, _objectSpread9.default)({}, getMap, (0, _defineProperty2.default)({}, dimensionName, function (index, key) {
          return _this4.scaledData[index][dimensionName][key];
        }));
      }, {}); // Build the customized scaled data for this child

      var scaledData = (inheritedProps.frame || inheritedProps.data).rows // map rows
      .map(function (row, index) {
        // then dimensions
        return _this4.dimensions.reduce(function (flattenedDimensions, _ref5) {
          var dimension = _ref5.dimension,
              dimensionName = _ref5.dimensionName;
          // Get dimension info for current component
          var appliedDimension = (0, _applyDimension2.default)(dimension, inheritedProps);
          var columnName = appliedDimension.columnName;
          var columns = [].concat(columnName); // calculate new dimensions to add to dimension Map. In most cases this
          // will be a single dimension (eg: x or y, etc) but if an array of columns
          // is supplied then newDimensoins will be a map with a entry for each
          // supplied column: eg: {x: 1, x0: 1, x2: 5, x3: 10}.

          var newDimensions = columns.reduce(function (newDimensions, column, dimensionIndex) {
            var multiColumn = columns.length > 1;
            var scaledValue = getters[dimensionName](index, column); // Always add the base dimension. This way components that don't know
            // about x0, x1 etc will still work because x is still defined.

            var withBaseDimension = dimensionIndex === 0 ? (0, _objectSpread9.default)({}, newDimensions, (0, _defineProperty2.default)({}, dimensionName, scaledValue)) : newDimensions; // If there are multiple columns specified then set the extra dimension
            // values with keys in the form `${dimensionName}${dimensionIndex}` - eg. x0

            return multiColumn ? (0, _objectSpread9.default)({}, withBaseDimension, (0, _defineProperty2.default)({}, "".concat(dimensionName).concat(dimensionIndex), scaledValue)) : withBaseDimension;
          }, {});
          return (0, _objectSpread9.default)({}, flattenedDimensions, newDimensions);
        }, {});
      });
      var scaleProps = this.dimensions.reduce(function (result, _ref6) {
        var dimension = _ref6.dimension,
            dimensionName = _ref6.dimensionName;
        var customScale = customScales.find(function (ii) {
          return ii.dimensionName === dimensionName;
        });
        return (0, _objectSpread9.default)({}, result, (0, _defineProperty2.default)({}, "".concat(dimensionName, "Scale"), (customScale || {}).scale || (dimension.scales[0] || {}).scale));
      }, {});
      return (0, _objectSpread9.default)({}, inheritedProps, {
        scaledData: scaledData,
        childChart: true
      }, scaleProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$applyCanvasSize = this.applyCanvasSize(this.props),
          width = _this$applyCanvasSize.width,
          height = _this$applyCanvasSize.height,
          outerWidth = _this$applyCanvasSize.outerWidth,
          outerHeight = _this$applyCanvasSize.outerHeight,
          top = _this$applyCanvasSize.top,
          left = _this$applyCanvasSize.left,
          _this$applyCanvasSize2 = _this$applyCanvasSize.stroke,
          stroke = _this$applyCanvasSize2 === void 0 ? 'black' : _this$applyCanvasSize2;

      var _this$props = this.props,
          className = _this$props.className,
          modifier = _this$props.modifier,
          _this$props$spruceNam = _this$props.spruceName,
          name = _this$props$spruceNam === void 0 ? 'PnutChart' : _this$props$spruceNam,
          Wrapper = _this$props.wrapper,
          ChildWrapper = _this$props.childWrapper,
          wrapperProps = _this$props.wrapperProps,
          childWrapperProps = _this$props.childWrapperProps,
          childChart = _this$props.childChart;
      var combinedWrapperProps = (0, _objectSpread9.default)({}, wrapperProps, {
        stroke: stroke,
        className: (0, _SpruceClassName.default)({
          name: name,
          modifier: modifier,
          className: className
        }),
        width: outerWidth,
        height: outerHeight
      });
      var combinedChildWrapperProps = (0, _objectSpread9.default)({}, childWrapperProps, {
        x: left,
        y: top,
        width: width,
        height: height
      });

      var scaledChildren = _react.Children.toArray(this.props.children).map(function (child) {
        return (0, _react.cloneElement)(child, _this5.getChildProps((0, _objectSpread9.default)({}, child.props, {
          chartType: child.type.chartType
        })));
      });

      var chart = _react.default.createElement(ChildWrapper, combinedChildWrapperProps, scaledChildren);

      if (childChart) {
        return chart;
      }

      return _react.default.createElement(Wrapper, combinedWrapperProps, chart);
    }
  }]);
  return Chart;
}(_react.Component);

(0, _defineProperty2.default)(Chart, "chartType", 'canvas');
(0, _defineProperty2.default)(Chart, "defaultProps", {
  dimensions: ['x', 'y'],
  wrapper: _Svg.default,
  wrapperProps: {},
  childWrapper: _Svg.default,
  childWrapperProps: {}
});
var _default = Chart;
exports.default = _default;